// Tiny module-level singleton for handing context from one admin page to
// another without extending the router with query-string parsing. The
// Suppliers page calls `setCurrentSupplier(...)` before `ctx.navigate("catalogue")`,
// and the catalogue viewer reads `getCurrentSupplier()` on mount.
//
// State is in-memory only — a full reload clears it. That's deliberate: the
// catalogue viewer is meant to be entered from the Suppliers list, not
// linked to directly.

export interface CatalogueSupplierRef {
  id: string;
  name: string;
}

let current: CatalogueSupplierRef | null = null;

export function setCurrentSupplier(ref: CatalogueSupplierRef | null): void {
  current = ref;
}

export function getCurrentSupplier(): CatalogueSupplierRef | null {
  return current;
}
